import { UserModel } from './user-model.model';
import { CompanyDetailViewModel } from '../../modules/company/models/company-detail-view.model';

export class CompanyUserViewModel {
    constructor(
        public user: UserModel,
        public id: number,
        public companyId: number,
        public userId: number,
        public isAdmin: boolean,
        public isApproved: boolean,
        public pendingUserCount?: number,
        public pendingUserCountChip?: any[],
        public company?: CompanyDetailViewModel,
    ) { }

    companyAccess?: string;
}
